import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Form, Row, Col, Image, Button } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import { FormControl, Select, InputLabel, Checkbox } from "@material-ui/core";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  InputBoxComponent,
  NewInputText,
  TextAreaReusableComponent,
} from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import PosData from "./PosDeatilsData";
import { Toggle } from "../../../superAdminReusable/reusableSuperAdminButton/Toggle";
import ConfigurePosDetails from "./ConfigurePosDetails";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ConfigurationApi from "./ConfigurationApi";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { pos_configuration_add } from "../../../../../store/actions/SuperAdminActions/adminPosconfigurationAdd";
import { useLocation } from "react-router-dom";
import { amApi } from "../../../../../api/apiHelper";

function AddPos(props) {
  let history = useHistory();

  const location = useLocation();

  const pos_config_id = location?.state?.pos_id;

  const [ShowTab, setShowTab] = useState("1");

  const [ApiPosData, SetPosData] = useState({});

  const handleShowTab = (e) => setShowTab(e);

  const token = props.auth.user.accessToken;

  const onSuccessPosConfigure = () => {
    history.push("/superadminposdashboard");
  };

  const formik = useFormik({
    initialValues: PosData.intialValues,
    validationSchema: PosData.validationSchema,
    onSubmit: (values) => {
      // if (location?.state?.pos_id) {
      //   values.pos_config_id = location?.state?.pos_id;
      // }
      // console.log(values);
      props.pos_configuration_add(token, values, onSuccessPosConfigure);
    },
  });


  useEffect(() => {
    if (location?.state?.pos_id) {
      fetchData();
    }
    async function fetchData() {
      let data = await amApi.get(`/admin/pos/${pos_config_id}`);
      console.log(data)
      SetPosData(data.data);
    } 
  },[]);

  useEffect(()=>{
    if(ApiPosData){
        formik.setFieldValue('environment',ApiPosData?.environment ? ApiPosData?.environment : "STAGING");
        formik.setFieldValue('staging_config.app_key',ApiPosData?.staging_config?.app_key ? ApiPosData?.staging_config?.app_key : "");
        formik.setFieldValue('staging_config.app_secret',ApiPosData?.staging_config?.app_secret ? ApiPosData?.staging_config?.app_secret : "");
        formik.setFieldValue('staging_config.access_token',ApiPosData?.staging_config?.access_token ? ApiPosData?.staging_config?.access_token : "");
        formik.setFieldValue('staging_config.base_url',ApiPosData?.staging_config?.base_url ? ApiPosData?.staging_config?.base_url : "");
        formik.setFieldValue('staging_config.api_key',ApiPosData?.staging_config?.api_key ? ApiPosData?.staging_config?.api_key : "");
        formik.setFieldValue('staging_config.password',ApiPosData?.staging_config?.password ? ApiPosData?.staging_config?.password : "");
        formik.setFieldValue('staging_config.save_order_url',ApiPosData?.staging_config?.save_order_url ? ApiPosData?.staging_config?.save_order_url : "");
        formik.setFieldValue('staging_config.update_order_url',ApiPosData?.staging_config?.update_order_url ? ApiPosData?.staging_config?.update_order_url : "");
        formik.setFieldValue('staging_config.rider_update_url',ApiPosData?.staging_config?.rider_update_url ? ApiPosData?.staging_config?.rider_update_url : "");
        formik.setFieldValue('production_config.app_key',ApiPosData?.production_config?.app_key ? ApiPosData?.production_config?.app_key : "");
        formik.setFieldValue('production_config.app_secret',ApiPosData?.production_config?.app_secret ? ApiPosData?.production_config?.app_secret : "");
        formik.setFieldValue('production_config.access_token',ApiPosData?.production_config?.access_token ? ApiPosData?.production_config?.access_token : "");
        formik.setFieldValue('production_config.base_url',ApiPosData?.production_config?.base_url ? ApiPosData?.production_config?.base_url : "");
        formik.setFieldValue('production_config.api_key',ApiPosData?.production_config?.api_key ? ApiPosData?.production_config?.api_key : "");
        formik.setFieldValue('production_config.password',ApiPosData?.production_config?.password ? ApiPosData?.production_config?.password : "");
        formik.setFieldValue('production_config.save_order_url',ApiPosData?.production_config?.save_order_url ? ApiPosData?.production_config?.save_order_url : "");
        formik.setFieldValue('production_config.update_order_url',ApiPosData?.production_config?.update_order_url ? ApiPosData?.production_config?.update_order_url : "");
        formik.setFieldValue('production_config.rider_update_url',ApiPosData?.production_config?.rider_update_url ? ApiPosData?.production_config?.rider_update_url : "");
    }
  },[ApiPosData])

 

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="pl-3 f24-700">
                  {ShowTab == 1 ? (
                    <>Configuration-POS Details </>
                  ) : ShowTab == 2 ? (
                    <> Configuration-API</>
                  ) : (
                    <>Configuration-Data Mapping</>
                  )}
                </div>
              </div>
 
              {ShowTab == 1 && (
                <ConfigurePosDetails
                  handleShowTab={handleShowTab}
                  formik={formik}
                  ApiPosData={ApiPosData}
                  edit={location?.state?.edit}
                />
              )}
              {ShowTab == 2 && (
                <ConfigurationApi
                  handleShowTab={handleShowTab}
                  formik={formik}
                />
              )}
              {ShowTab == 3 && (
                <div>
                  <div>
                    <div className="f12-500 my-4">Restaurant Session</div>
                    <div
                      type="none"
                      className={"enStatusList d-flex"}
                      style={{
                        justifyContent: "left",
                        flexWrap: "inherit",
                        width: "50%",
                      }}
                    >
                      <li style={{ width: "68%", fontSize: "14px" }}>
                        Upload Data Mapping
                      </li>
                      <li style={{ width: "68%", fontSize: "14px" }}>
                        View Mapping
                      </li>
                    </div>
                    <div className="f12-500 my-4">Menu Availibility</div>

                    <div
                      type="none"
                      className={"enStatusList d-flex"}
                      style={{
                        justifyContent: "left",
                        flexWrap: "inherit",
                        width: "50%",
                      }}
                    >
                      <li style={{ width: "68%", fontSize: "14px" }}>
                        Upload Data Mapping
                      </li>
                      <li style={{ width: "68%", fontSize: "14px" }}>
                        View Mapping
                      </li>
                    </div>
                    <div className="f12-500 my-4">Menu Upload</div>

                    <div
                      type="none"
                      className={"enStatusList d-flex"}
                      style={{
                        justifyContent: "left",
                        flexWrap: "inherit",
                        width: "50%",
                      }}
                    >
                      <li style={{ width: "68%", fontSize: "14px" }}>
                        Upload Data Mapping
                      </li>
                      <li style={{ width: "68%", fontSize: "14px" }}>
                        View Mapping
                      </li>
                    </div>
                    <div className="f12-500 my-4">Order Exchange</div>

                    <div
                      type="none"
                      className={"enStatusList d-flex"}
                      style={{
                        justifyContent: "left",
                        flexWrap: "inherit",
                        width: "50%",
                      }}
                    >
                      <li style={{ width: "68%", fontSize: "14px" }}>
                        Upload Data Mapping
                      </li>
                      <li style={{ width: "68%", fontSize: "14px" }}>
                        View Mapping
                      </li>
                    </div>
                    <div className="f12-500 my-4">Menu price Update</div>

                    <div
                      type="none"
                      className={"enStatusList d-flex"}
                      style={{
                        justifyContent: "left",
                        flexWrap: "inherit",
                        width: "50%",
                      }}
                    >
                      <li style={{ width: "68%", fontSize: "14px" }}>
                        Upload Data Mapping
                      </li>
                      <li style={{ width: "68%", fontSize: "14px" }}>
                        View Mapping
                      </li>
                    </div>
                    <div className="f12-500 my-4">Offers</div>

                    <div
                      type="none"
                      className={"enStatusList d-flex"}
                      style={{
                        justifyContent: "left",
                        flexWrap: "inherit",
                        width: "50%",
                      }}
                    >
                      <li style={{ width: "68%", fontSize: "14px" }}>
                        Upload Data Mapping
                      </li>
                      <li style={{ width: "68%", fontSize: "14px" }}>
                        View Mapping
                      </li>
                    </div>
                  </div>
                  <div className="py-4 d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5 btn150px"
                      onClick={(e) => handleShowTab("2")}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5 btn150px"
                      //type="submit"
                      onClick={(e) => handleShowTab("1")}
                    >
                      Next
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
//export default AddPos;

AddPos.propTypes = {
  auth: PropTypes.object.isRequired,
  pos_configuration_add: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  pos_configuration_add,
})(AddPos);
